import React from 'react'
import { Stat, StatLabel, StatNumber, SimpleGrid, Box } from '@chakra-ui/react'
import Card from '../../Card'
import { CardProps } from '../../Card'
import {
  useCountAgentPropertiesQuery,
  Enum_Property_Publish_State,
  useGetAgencyAgentsCountQuery,
  Enum_Agent_Status
} from 'generated/graphql'
import { useAppContext } from 'context/AppProvider'

const cardStyles: CardProps = {
  width: '100%',
  shadow: 'none',
  border: 'none'
}
type PreviewerProps = {}

const Previewer: React.FC<PreviewerProps> = ({}) => {
  const { secondaryDrawerOpen, previewComponent } = useAppContext()
  const { data: propertiesCount } = useCountAgentPropertiesQuery({
    variables: {
      where: {
        publish_state: Enum_Property_Publish_State.Active
      }
    }
  })
  const { data: propertiesInactiveCount } = useCountAgentPropertiesQuery({
    variables: {
      where: {
        publish_state: Enum_Property_Publish_State.Inactive
      }
    }
  })
  const { data: agentUsersCount } = useGetAgencyAgentsCountQuery({
    variables: {
      where: {
        status: Enum_Agent_Status.Active
      }
    },
    fetchPolicy: 'cache-and-network'
  })

  const { data: adminUsersCount } = useGetAgencyAgentsCountQuery({
    variables: {
      where: {
        'user.role.type': 'admin',
        status: Enum_Agent_Status.Active
      }
    },

    fetchPolicy: 'cache-and-network'
  })
  const stats = [
    {
      title: secondaryDrawerOpen ? 'Active Properties' : 'Active Properties',
      count: propertiesCount?.countAgentProperties || 0,
      activity: '0.0%',
      arrowType: 'increase'
    },
    {
      title: secondaryDrawerOpen ? 'Inactive Properties' : 'Inactive Properties',
      count: propertiesInactiveCount?.countAgentProperties || 0,
      activity: '0.0%',
      arrowType: 'decrease'
    },
    {
      title: secondaryDrawerOpen ? 'Active Agents' : 'Agents',
      count: agentUsersCount?.getAgencyAgentsCount || 0,
      activity: '0.0%',
      arrowType: 'increase'
    },
    {
      title: secondaryDrawerOpen ? 'Active Admin Users' : 'Admin',
      count: adminUsersCount?.getAgencyAgentsCount || 0,
      activity: '0.0%',
      arrowType: 'increase'
    }
  ]
  return previewComponent && secondaryDrawerOpen ? (
    <Box height="100vh" width="100%" overflowY="auto">
      {previewComponent}
    </Box>
  ) : (
    <Box px={1} py={4} w="100%">
      <SimpleGrid
        flex={1}
        justifyItems="flex-start"
        alignItems="flex-start"
        overflowY="auto"
        h="50vh"
        w="100%"
        columns={secondaryDrawerOpen ? 2 : 1}
      >
        {stats.map((stat) => (
          <Card
            p={secondaryDrawerOpen ? 10 : 0}
            width={secondaryDrawerOpen ? '50%' : '100%'}
            key={stat.title}
            {...(!secondaryDrawerOpen && {
              p: 0,
              textAlign: 'center'
            })}
            {...cardStyles}
          >
            <Stat width="100%">
              <StatLabel
                mb={secondaryDrawerOpen ? 4 : 2}
                color="gray.500"
                lineHeight="1.5"
                fontWeight="semibold"
                fontSize={secondaryDrawerOpen ? 'xs' : 'x-small'}
              >
                {stat.title}
              </StatLabel>
              <StatNumber fontSize={secondaryDrawerOpen ? '5xl' : '2xl'} fontWeight="extrabold">
                {stat.count}
              </StatNumber>
            </Stat>
          </Card>
        ))}
      </SimpleGrid>
    </Box>
  )
}

export default Previewer
